import SimpleModal from  '@/components/simple_modal'
import {useState, useRef} from 'react'; 
import PhotometryViewer from '@/components/photometry_viewer'
import PhotometrySvg from '@/components/svgs/photometry_svg'
import useOutsideClick from '@/components/close_modal_outside_click';

export default function PhotometryButton({product, _classes}) {
  const [show, setShow] = useState(false)
  const modalBody = useRef()
   useOutsideClick(modalBody, () => setShow(false) )

  return (
    <>
      {product.photometry_options &&
           <a
             className={_classes ? _classes : "lexcms-large-button  lexcms-photometry-button" }
             onClick={() => setShow(true)  } 
           >
             <PhotometrySvg/> Photometric Viewer
          </a>
      }
      
      {show &&
      <div className='lexcms-photometry-modal-overlay'>
      <SimpleModal theRef={modalBody}  show={show} setShow={setShow}  additionalClasses={'lexcms-photometry-modal'} >
        <PhotometryViewer product={product} />
      </SimpleModal>
      </div>
      }

    </>
  )

}
